import {createContext, useContext} from 'react'

// Use a plain React context with a safe default so `useMyRewardsStyles()` returns {}
// when called outside `MyRewardsStylesProvider` (e.g. GDIRewardTileBlock on non-rewards pages).
const MyRewardsStylesContext = createContext({})

const MyRewardsStylesProvider = MyRewardsStylesContext.Provider

const useMyRewardsStyles = () => useContext(MyRewardsStylesContext)

export {MyRewardsStylesProvider, useMyRewardsStyles}
